#import "../../../graphql/fragments/email-attachment.graphql"
#import "./nut-email-address.graphql"

fragment QueuedEmail on EmailQueued {
    id
    to {
        ...NutEmailAddress
    }
    cc {
        ...NutEmailAddress
    }
    from {
        ...NutEmailAddress
    }
    messageNumber
    subject
    bodyText
    bodyHtml
    attachments {
        ...EmailAttachment
    }
    deliveryTime
    emailSequence {
        id
        messageCount
        emailSequenceTemplate {
            id
            name
        }
    }
    htmlUrl
    status
    sendProblems
    canRetry
    isNextScheduledEmail
    canDelay
    sendAsReply
}
